import { Carousel } from "antd"

import p1 from '../../../assets/1.jpg'
import p2 from '../../../assets/2.jpg'
import p3 from '../../../assets/3.jpg'
import p4 from '../../../assets/4.jpg'

const BannerCarousel = props => {

    const imgs = [p1, p2, p3, p4]

    return <div className="carousel">
        <Carousel autoplay draggable arrows>
            {imgs.map((im, ix) => <div className="img-container" key={ix}>
                <img src={im} alt='' />
            </div>)}
        </Carousel >
    </div >
}

export default BannerCarousel
